import { CreateRequestResponse } from 'api/premiumUserAPI/specialServicesAPI'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {
  id: string
} & Status

const initialState: State = {
  id: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.CREATE_CONSULTANCY_REQUEST_ASYNC,
    Actions.CREATE_CONSULTANCY_REQUEST_SUCCESS,
    Actions.CREATE_CONSULTANCY_REQUEST_FAIL,
    CreateRequestResponse
  >,
) => {
  switch (action.type) {
    case Actions.CREATE_CONSULTANCY_REQUEST_ASYNC:
    case Actions.CREATE_CONSULTANCY_REQUEST_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.CREATE_CONSULTANCY_REQUEST_SUCCESS: {
      return {
        ...state,
        ...action.status,
        id: action.payload.data.display_id,
      }
    }
    default:
      return state
  }
}
